import { Component,ViewChild } from '@angular/core';
import { NavController,ViewController,NavParams,Platform } from 'ionic-angular';
import { TranslateService } from '@ngx-translate/core';
import { Storage } from '@ionic/storage';
import { provider } from '../../../providers/provider';
import { Slides } from 'ionic-angular';
import { ProductsHorizontalPage } from '../productsHorizontal/productsHorizontal';
import { ProductsVerticalPage } from '../productsVertical/productsVertical';
import { ProductsWithImageList } from '../productsWithImageList/productsWithImageList';
import { productDetailPage } from '../../productDetail/productDetail';
import { CartPage } from '../../cart/cart';
import { CustomizerProvider } from '../../../providers/customizer/customizer';
import { isUndefined } from 'util';

@Component({
  selector: 'page-products-noimagelist',
  templateUrl: 'productsNoImageList.html'
})
export class ProductsNoImageListPage {
  @ViewChild(Slides) slides: Slides;
  url: any;
  groupId = '';
  groupContentId = '';
  group: any;
  viewType = 'no-list-image';
  groupContent: any;
  data: any;
  tot = 0;
  width: any;
  height: any;
  regex = /(<([^>]+)>)/ig;

  constructor(public navCtrl: NavController,
              public navParams: NavParams,
              public translateService: TranslateService,
              public storage: Storage,
              public viewCtrl: ViewController,
              public provider: provider,
              public customizer: CustomizerProvider,
              public platform: Platform) {
    this.url = provider.getUrl();
    this.data = provider.getMenu();
    this.group = navParams.get('group');
    this.groupId = this.group._id;
    this.groupContentId = this.group.content._id;
    this.groupContent = this.group.content;

    platform.ready().then((readySource) => {
      this.width = platform.width();
      this.height = platform.height();
    });
  }

  getIngredients(obj) {
    let varIngr=[],ingredients=[];
    for(let j=0; j<obj.content.varIngr.length; j++) {
      for(let i=0; i<this.data.lib.length; i++) {
        if(this.data.lib[i]._id == obj.content.varIngr[j]) {
          varIngr.push(JSON.parse(JSON.stringify(this.data.lib[i])));
        }
      }
    }
    for(let j=0; j<varIngr.length;j++) {
      ingredients.push(`
      <p padding-horizontal text-center text-lowercase>
        <span [ngClass]="{allergene:${obj.content.extraProps.allergene}}" *ngIf="!last">{{provider.renderDescr(${varIngr[j]})}} | </span>
        <span [ngClass]="{allergene:${obj.content.extraProps.allergene}}" *ngIf="last">{{provider.renderDescr(${varIngr[j]})}}</span>
      </p>
      `)
    }
    return ingredients
  }

  showProducts(group) {
    //pubblicità
    let isAdv = this.data.menu.righe.filter((element) => element.parent == group._id);
    if (isAdv.length == 0) return;

    if(group.viewType == 'vertical') 
      this.navCtrl.push(ProductsVerticalPage, { group: group });
    else if(group.viewType == 'horizontal') 
      this.navCtrl.push(ProductsHorizontalPage, { group: group });
    else if(group.viewType == 'image-list') 
      this.navCtrl.push(ProductsWithImageList, { group: group });
    else
      this.navCtrl.push(ProductsNoImageListPage, { group: group });
  }
  showProduct(product) {
    this.navCtrl.push(productDetailPage, { product: product });
  }
  cart() {
    this.navCtrl.push(CartPage);
  }

  ionViewDidEnter() {
    this.tot = this.provider.showTotal();
  }

  ionViewDidLoad() {
  }

  // modalità sfoglia menu con scroll

  getImg(img) {
    return 'assets/ALLERGENI/' + img + '.png';
  }

  // check for extended description
  hasExtendedDescription(group) : Boolean {
    return (group.descrizioneEstesa != undefined && group.descrizioneEstesa[0] != undefined && group.descrizioneEstesa[0].contenuto != '');
  }

}




// WEBPACK FOOTER //
// ./src/pages/products/productsNoImageList/productsNoImageList.ts